import * as React from "react";
import { BlossomComponentTreeStore } from "./BlossomComponentTreeStore";

/**
 * TEMPORARY WILL BE UNNECESSARY AFTER HYBRID BLOSSOM REFACTOR COMPLETE
 * allows us to inject BlossomComponentTreeStore without messing with props types
 * ultimately a component's BlossomComponent will be handed to it directly so access to the entire
 * BlossomComponentTree will not be necessary
 */
export const BlossomComponentTreeContext = React.createContext<BlossomComponentTreeStore | undefined>(undefined);
